/**
 * Configuración global de mutations
 */
export const ON_ROUTE = "ON_ROUTE";
export const ON_IS_LOADING = "ON_IS_LOADING";
export const ON_LANDING = "ON_LANDING";
export const ON_PASO_1 = "ON_PASO_1";
export const ON_PASO_2 = "ON_PASO_2";
export const ON_PASO_3 = "ON_PASO_3";
export const ON_PASO_4 = "ON_PASO_4";
export const ON_CAMPANIA = "ON_CAMPANIA";
export const ON_URL = "ON_URL";
export const ON_GRACIAS = "ON_GRACIAS";
export const ON_NOTIFICATION_TOAST = "ON_NOTIFICATION_TOAST";
export const ADOBE_INTERNAL_LINK = "ADOBE_INTERNAL_LINK";
export const ADOBE_APP_STARTED = "ADOBE_APP_STARTED";
export const ON_TIPO_ERROR = "ON_TIPO_ERROR";
export const ON_TCODE = "ON_TCODE";
export const ON_USER_ID_TOKENIZADO = "ON_USER_ID_TOKENIZADO";
